import {ActionInterface} from '../../wizard/types/mx/actions';

export const ADD_ALERT_ACTION: ActionInterface = {
    name: 'ADD_ALERT_ACTION',
    action: (title: string, description: string, alertType: boolean = true) => ({
        title,
        description,
        alertType,
        type: ADD_ALERT_ACTION.name
    })
};
export const REMOVE_ALERT_ACTION: ActionInterface = {
    name: 'REMOVE_ALERT_ACTION',
    action: (key: number | string) => ({
        key,
        type: REMOVE_ALERT_ACTION.name
    })
};
